import createClient from './createClient';

export const BASE_URL = 'http://localhost:8080';

export default createClient({
  baseURL: BASE_URL,
});
